// Shop-currency (USD) cents -> the visitor's currency. Shopify converts
// shipping rates and thresholds with window.Shopify.currency.rate and no
// rounding, so this matches what checkout charges.
export function rate() {
  const r = Number(globalThis.Shopify?.currency?.rate);
  return r > 0 ? r : 1;
}

export function toLocal(usdCents) {
  return Math.round(Number(usdCents) * rate());
}

// `sample` is the store's own money format for 1234.56 (Liquid `123456 | money`, e.g.
// "€1.234,56"), so converted amounts look like every other price on the page.
// Without it, fall back to Intl.
export function formatMoney(cents, sample) {
  const m = sample && String(sample).match(/1(\D?)234(\D)56/);
  if (m) {
    const [whole, frac] = (Math.round(cents) / 100).toFixed(2).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
    return String(sample).replace(m[0], grouped + m[2] + frac);
  }
  const currency = globalThis.Shopify?.currency?.active || 'USD';
  const locale = globalThis.document?.documentElement.lang || undefined;
  let fmt;
  try { fmt = new Intl.NumberFormat(locale, { style: 'currency', currency }); }
  catch { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency }); }
  return fmt.format(cents / 100);
}

// <span data-gm-usd="4000" data-gm-format="€1.234,56">$40</span> -> "€35,54" for a euro visitor.
export function convertAll(root = document) {
  root.querySelectorAll('[data-gm-usd]').forEach((el) => {
    el.textContent = formatMoney(toLocal(el.dataset.gmUsd), el.dataset.gmFormat);
  });
}

// Node (tests/unit) imports this through gm-bundle.js and has no DOM.
if (typeof document !== 'undefined') convertAll();
